
export const getFileFromDataURI = ({dataURI, filename}) => {
  const [head, encoded_image] = dataURI.split(",");
  const mime = head.match(/:(.*?);/)[1];

  return fetch(dataURI)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], filename,{type:mime});})
};
